// Homepage strip: latest 3 AI news stories. Hides itself when no news yet.
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Newspaper, ChevronRight } from "lucide-react";
import { API } from "../../utils/apiUrl";
import { NewsCard } from "./NewsCard";

const HomeNewsStrip = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    axios.get(`${API}/news?limit=3`).then((r) => setArticles(r.data.articles || [])).catch(() => {});
  }, []);
  if (!articles.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-4 py-10" data-testid="home-news-strip">
      <div className="flex items-end justify-between mb-5 gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <Newspaper className="w-5 h-5 text-emerald-300" />
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            LATEST SPORTS NEWS
          </h2>
        </div>
        <Link to="/news" className="inline-flex items-center gap-1 text-emerald-300 hover:text-emerald-200 text-sm font-bold" data-testid="home-news-all-link">
          All news <ChevronRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {articles.map((a) => <NewsCard key={a.slug} a={a} />)}
      </div>
    </section>
  );
};

export default HomeNewsStrip;
